import { Error } from "./Messages/Messages";
export const generalErrorAlert = err => {
  if (err?.response && err?.response?.data && err?.response?.data?.errors) {
    const validationErrors = err.response.data.errors;
    const firstError = Object.values(validationErrors)[0];
    if (firstError?.name === "CastError") {
      Error(`${firstError?.path} must be a valid ${firstError?.kind}.`);
    } else {
      Error(firstError?.message);
    }
  } else if (err?.response?.data?.keyPattern) {
    Error(Object.keys(err.response.data.keyPattern) + " already exists");
  } else if (err?.response?.data?.errorMessage) {
    Error(err.response.data.errorMessage);
  } else {
    Error(err.message);
  }
};
